export default {
  id: 'gruas-saltillo',
  displayName: 'Gruas Saltillo',
  topbarColor: '#ffc434',
  topbarLogo: require('@/assets/logo-saltillo.png'),
}
